import React, { useEffect } from "react";
import { Row, Container, Col, Image } from "react-bootstrap";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";

import Title from "../TitleIzquierda";
import { equipoData } from "../../constants/equipoData";

import "../../styles/components/Equipo.scss";

const boxVariant = {
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  hidden: { opacity: 0, y: 200 },
};

export default function Equipos() {
  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("visible");
    }
  }, [control, inView]);

  return (
    <section id="equipos">
      <motion.div
        className="box equipo pb-5 backgroundEquipo"
        ref={ref}
        variants={boxVariant}
        initial="hidden"
        animate={control}
      >
        <Title titulo="Equipos e Instrumentación" scroll={inView} />
        <Container className="mt-3">
          <Row>
            <p className="text-white">
              Nuestro objetivo es ofrecer a nuestros clientes los mejores
              servicios de ingeniería y supervisión tecnificada, cumpliendo con
              los requerimientos de ejecución de obras de manera segura, eficiente
              y oportuna. Nos esforzamos por entregar servicios con el más alto
              índice de calidad.
            </p>
          </Row>
          <Row className="justify-content-between" xl={4} lg={4} md={3} sm={2} xs={1}>
            {equipoData.map((data) => (
              <Col className="fondoCard m-1" key={data.idEquipo}>
                <Image
                  src={data.img}
                  alt={data.alt}
                  width={data.width}
                  height={data.height}
                  className="imageCard"
                />
                <div className="m-2 textCard">{data.texto}</div>
              </Col>
            ))}
          </Row>
        </Container>
      </motion.div>
    </section>    
  );
}